import { Button, Dropdown, Menu, message, Typography, Modal } from "antd";
import TableWrap from "../Common/Table/Table";
import DropdownIcon from "../../assets/icons/dropdown_icon.png";

import React from "react";
// import moment from "moment";

import "./report.css";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteExpense,
  expenses_delete,
} from "../../actions/expenses/expenses";

message.config({
  maxCount: 3,
});
const Text = Typography.Text;

const ReportTrips = (props) => {
  const history = useHistory();
  const [expenseSelectedData, setExpensesSelectedData] = React.useState("");
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const deleteExpResponse = useSelector(
    (state) => state.reports.deleteExpense || {},
  );
  const dispatch = useDispatch();

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      deleteExpResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch({
        type: DeleteExpense.RESET,
      });
      props.callExpenseDetails();
    } else {
      if (res_message) {
        dispatch({
          type: DeleteExpense.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteExpResponse]);
  const columns = [
    {
      title: "Trip ID",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "Trip Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Date - Time",
      dataIndex: "created_at",
      key: "created_at",
      // render: (text) => <div>{moment(text).format("DD MMM YYYY")}</div>,
    },
    {
      title: "Emp Name",
      dataIndex: "employee_name",
      key: "employee_name",
    },
    {
      title: "Trip Type",
      dataIndex: "trip_type",
      key: "trip_type",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <div className={`status status_${text}`}>{text.replace(/_/g, " ")}</div>
      ),
    },
    {
      title: "",
      dataIndex: "id",
      key: "id",
      render: (text, record) => {
        return props.reportStatus === "unsubmitted" ? (
          <Dropdown overlay={menu(record)} placement="bottomRight">
            <img src={DropdownIcon} alt={"logo"} className="action-logo" />
          </Dropdown>
        ) : null;
      },
    },
  ];

  const menu = (record) => (
    <Menu
      onClick={(e) => {
        e.domEvent.stopPropagation();
        handleMenuClick(e, record);
      }}
    >
      <Menu.Item key="1">Unlink Trip</Menu.Item>
    </Menu>
  );

  const renderDelete = () => {
    return (
      <>
        <Text>Are you sure you want to unlink trip from this report.</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          disabled={deleteExpResponse?.loading}
          onClick={() => {
            dispatch(
              expenses_delete({
                trips: [expenseSelectedData],
                unlink: true,
                trip: true,
              }),
            );
          }}
        >
          Unlink
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => {
            setIsModalVisible(false);
            setExpensesSelectedData("");
          }}
        >
          Cancel
        </Button>
      </>
    );
  };

  function handleMenuClick(e, record) {
    switch (e.key) {
      case "1":
        setIsModalVisible(true);
        setExpensesSelectedData(record.id);
        break;
      case "2":
        // setReasonValue('')
        break;
      default:
    }
  }
  return (
    <div className="expenses-table">
      <Modal
        title={"Unlink Trip"}
        visible={isModalVisible}
        onCancel={() => {
          setExpensesSelectedData("");
          setIsModalVisible(false);
        }}
        footer={[]}
        className="center-aligned-modal"
      >
        {renderDelete()}
      </Modal>
      <TableWrap
        columns={is_admin ? columns?.slice(0, columns.length - 1) : columns}
        data={props.reportsTripData}
        pagination={false}
        handleRowClick={(evt, record) => {
          evt.preventDefault();
          if (record) {
            history.push({
              pathname: `/trip-details/${record.id}`,
              state: { tripData: record },
            });
          }
        }}
      />
    </div>
  );
};

export default ReportTrips;
